<template>
    <!-- 결제정보 자동 등록 팝업 -->
    <div v-show='show' class='layer-pop square-type'>
        <div class='view-content' style='width: 640px;'>
            <button class='close' @click='onClosePop'><span class='blind'>팝업 닫기</span></button>
            <div class="px-6">
              <p class='sub-title mb-4'>핏페이 신청 내역</p>
              <span class="text-primary">{{ centerName }}</span>
            </div>
            
            <div class='scroll-area com-scroll-y px-6'>
              <div class='com-table-wrap mt-3'>
                <table class='com-table'>
                  <colgroup>
                    <col style='width:160px'>
                    <col style='width:auto'>
                    <col style='width:160px'>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>처리일</th>
                      <th>처리상태</th>
                      <th>담당자</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for='(p, index) in requestList' :key='index' class='pointer select-none'>
                      <td>{{p.cf_upd_dt | timestampFilter}}</td>
                      <td>
                        <span v-if='p.cf_status === "P"' class="link underline">미승인</span>
                        <span v-if='p.cf_status === "D"' class="link underline">승인완료</span>
                        <span v-if='p.cf_status === "R"' class="link underline">반려</span>
                      </td>
                      <td>{{p.namee}}</td>
                    </tr>
                    <tr v-if='requestList.length === 0'>
                        <td colspan='100'>
                          <loading-spinner v-if='loading' :height='120'></loading-spinner>
                          <span v-else>신청내역이 없습니다.</span>
                        </td>
                    </tr>
                  </tbody>
                </table>

                <b-pagination
                    v-model='pagingInfo.page'
                    :per-page='pagingInfo.limit'
                    :total-rows='pagingInfo.totalItems'
                    align='center'
                    aria-controls='my-table'
                    first-class='first'
                    last-class='last'
                    next-class='next'
                    prev-class='prev'
                    @change='handlerPagenation($event)'
                />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  name: 'FitpayRequestListDlg',
  components: { LoadingSpinner },
  props: {
    show: Boolean,
    close: Function,
    centerId: [String, Number],
    centerName: String,
  },
  watch: {
    show(v){
      if(v) {
        this.fetchrequestList(1)
      }
    }
  },
  data() {
    return {
      loading: false,
      requestList: [],
      pagingInfo: {
        page: 1, // 페이지
        limit: 5, // 한 목록에 표출되는 건수
        totalItems: '', // 총 Item 수
        itemCount: '', // 현재 페이지 item 수
        totalPages: '', // 총 페이지 수
        route: '', // 링크 경로 생성시 프리픽스
      }
    };
  },
  methods: {
    async fetchrequestList(pageNum) {
      if(this.loading) return
      
      this.loading = true

      try {
        const res = await api.get(`/admin/api/center/fitpay/list/${this.centerId}`, {
          params: { 
              ...this.pagingInfo, 
              page: pageNum || this.pagingInfo.page,
          },
        });

        this.loading = false
        if(res.data) {
          this.requestList = res.data.items || [];

          const metaData = res.data.meta;
          this.pagingInfo = {
              ...this.pagingInfo,
              page: metaData.currentPage,
              totalItems: metaData.totalItems, // 총 Item 수
              itemCount: metaData.itemCount, // 현재 페이지 item 수
              totalPages: metaData.totalPages, // 총 페이지 수
          }
        }
      } catch (error) {
        this.loading = false
        alert('이용권 목록을 불러오는 중 오류가 발생했습니다.');
      }
    },

    onClosePop() {
      this.close();
    },
    
  },
};
</script>
<style scoped>
</style>
